import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to (0, 0) on route change. React Router 6 doesn't
 * restore scroll by default, which means navigating from a long page (Journal)
 * to a short one (Dashboard) lands the user mid-page.
 *
 * Mount once near the top of the app tree (App.js).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // 'auto' keeps it instant — using 'smooth' on every nav feels too slow.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
